// extracted by mini-css-extract-plugin
module.exports = {"wrap":"animation-3d_wrap_1gDpL","canvas":"animation-3d_canvas_1o0wT"};